import type { MedNecCaseSliceState } from '../state';

export const editTrackingReducers = {
  markAsSaved: (state: MedNecCaseSliceState) => {
    state.isEdited = false;
    state.editedFields = [];
  },

  discardChanges: (state: MedNecCaseSliceState) => {
    if (state.serverCase) {
      state.currentCase = JSON.parse(JSON.stringify(state.serverCase));
    }
    state.isEdited = false;
    state.editedFields = [];
  },

  resetCase: (state: MedNecCaseSliceState) => {
    state.currentCase = null;
    state.selectedCaseId = null;
    state.isEdited = false;
    state.editedFields = [];
  },
};
